import { useEffect, useRef } from "react";
import { useNameDrop } from "../../../context/NameDropContext";

type Props = {
    vidalyticsId: string,
    vidalyticsUrl: string,
    nameDropTime: number,
    title: string,
    subtitle: string
};

const VslVideo = ({
    vidalyticsId,
    vidalyticsUrl,
    nameDropTime,
    title,
    subtitle
}: Props) => {
    const hasTriggered = useRef(false);
    const { isNameDropSeen, setNameDropSeen } = useNameDrop();

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.innerHTML = `
              (function (v, i, d, a, l, y, t, c, s) {
            y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
            if (!vsl){vsl=function(u,cb){
                if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
                if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
                i.getElementsByTagName("head")[0].appendChild(s);
            };}
            vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
        })(window, document, 'Vidalytics', '${vidalyticsId}', '${vidalyticsUrl}');
            `;
        document.body.appendChild(script);
        // Hook into XMLHttpRequest to monitor /scribe POSTs
        const originalSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function (body) {
            if (
                this instanceof XMLHttpRequest &&
                typeof body === "string" &&
                this._url?.includes("/scribe")
            ) {
                try {
                    const parsed = JSON.parse(body);
                    const events = parsed.events || [];

                    for (const event of events) {
                        if (
                            typeof event.videoTime === "number" &&
                            event.videoTime >= nameDropTime &&
                            !hasTriggered.current
                        ) {
                            hasTriggered.current = true;

                            setTimeout(() => {
                                setNameDropSeen();
                            }, 0);
                            break;
                        }
                    }
                } catch (e) {
                    console.warn("Failed to parse /scribe payload", e);
                }
            }

            return originalSend.apply(this, arguments as any);
        };

        const originalOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (
            this: XMLHttpRequest,
            method: string,
            url: string | URL,
            async?: boolean,
            username?: string | null,
            password?: string | null
        ): void {
            this._url = typeof url === "string" ? url : url.toString();
            return originalOpen.call(this, method, url, async ?? true, username, password);
        };

        return () => {
            document.body.removeChild(script);
            XMLHttpRequest.prototype.send = originalSend;
            XMLHttpRequest.prototype.open = originalOpen;
        };
    }, [vidalyticsId, vidalyticsUrl, nameDropTime]);

    return (
        <section id="video" className="gg-bg-solid-green-light">
            <div className="container-fluid pt-4 pb-4 text-center">
                <div className="row pb-4 align-items-center justify-content-center">
                    <div className="col-md-10 col-11">
                        <h1 className="fw-bold gg-line-height-14">{title}</h1>
                    </div>
                </div>
                <div className="row pb-3 align-items-center justify-content-center">
                    <div className="col-md-9 col-10">
                        <p className="fs-5 fw-bold gg-line-height-14"><mark className="gg-mark-yellow">{subtitle}</mark></p>
                    </div>
                </div>
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-9 col-sm-10 col-11 mb-3">
                        <div id={vidalyticsId}></div>
                    </div>
                    <div>
                        IMPORTANT WELLBEING ANNOUNCEMENT! Make sure your sound is ON. May take up to 30 seconds to load.
                    </div>
                </div>
                {
                    isNameDropSeen &&
                    <>
                        <div className="row align-items-center justify-content-center mt-4">
                            <div className="col-md-9 col-10">
                                <p className="fs-5">Discover the original formula created by Dr. Hart that supports healthy blood sugar balance without restricting your favorite meals.</p>
                            </div>
                        </div>
                    </>
                }
            </div>
        </section>
    );
};

export default VslVideo;